export const getColorByType = (type: string): string => {
  switch (type) {
    case 'farmers':
      return '#DB9030';
    case 'factories':
      return '#6A88B2';
    case 'forests':
      return '#84A341';
    default:
      return '#ffffff';
  }
};
